(function () {
  function addHeroOverlay() {
    var heroes = document.querySelectorAll(
      '.ecom-builder .ecom-9dr952cddk, .ecom-builder .ecom-h8f8z2rvfv7'
    );

    heroes.forEach(function (hero) {
      if (hero.querySelector('.memx-hero-overlay')) return;

      var overlay = document.createElement('div');
      overlay.className = 'memx-hero-overlay';
      overlay.innerHTML = [
        '<p class="memx-hero-overlay__eyebrow">Nostalgia, Replayed</p>',
        '<h1 class="memx-hero-overlay__title">The Soundtrack Of Then, Built For Now.</h1>',
        '<p class="memx-hero-overlay__text">Rediscover the formats, textures, and rituals that made listening feel personal.</p>',
        '<a class="memx-hero-overlay__button" href="/collections/shop-all">Discover now</a>'
      ].join('');

      hero.appendChild(overlay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addHeroOverlay);
  } else {
    addHeroOverlay();
  }
})();


/* Product page delivery features, set by market (added 16 Oct 2026).
   Lives here, not in EComposer, so publishing in EComposer cannot overwrite it. */
(function () {
  function setDeliveryFeatures() {
    var c = (window.Shopify && window.Shopify.country) || '';
    var ship = c === 'HK' ? 'Free delivery in Hong Kong'
      : c === 'US' ? 'Free US delivery over $150'
      : 'Free UK delivery over £100';
    var eta = c === 'HK' ? 'Dispatched in 1 to 3 business days'
      : c === 'US' ? 'Tracked delivery by FedEx'
      : 'Delivered in 2 to 6 business days';
    document.querySelectorAll('.element__featured--box-text').forEach(function (el) {
      var t = el.textContent || '';
      if (/free shipping|free delivery|free uk|free us|localization/i.test(t)) {
        el.innerHTML = '<div>' + ship + '</div>';
      } else if (/estimated delivery|delivered in|dispatched in|tracked delivery/i.test(t)) {
        el.innerHTML = '<div>' + eta + '</div>';
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setDeliveryFeatures);
  } else {
    setDeliveryFeatures();
  }
})();